/**
 * Web application entry point (prompt.md §37).
 *
 * The theme stylesheet is generated from `@dayvise/design-tokens` and injected
 * once, so every component in the tree — shared packages included — reads the
 * same `--dayvise-*` custom properties and a scheme change is an attribute flip.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { dayviseStylesheet } from "@dayvise/react-ui";
import { App } from "./App.tsx";

function injectTheme(): void {
  const style = document.createElement("style");
  style.setAttribute("data-dayvise", "theme");
  style.textContent = dayviseStylesheet();
  document.head.append(style);
}

injectTheme();

const container = document.getElementById("root");
if (container === null) throw new Error("the #root element is missing from index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
